import { createContext, useContext } from 'react';
import { jsx } from 'react/jsx-runtime';

const I18nContext = /*#__PURE__*/createContext({
  locale: 'en-US'
});
function I18nProvider(props) {
  const {
    children,
    ...rest
  } = props;
  return /*#__PURE__*/jsx(I18nContext.Provider, {
    value: rest,
    children: props.children
  });
}

/**
 * @deprecated prefer `useI18n()` instead
 */
function useLocale() {
  const ctx = useContext(I18nContext);
  return ctx.locale;
}
function useI18n() {
  return useContext(I18nContext);
}

export { I18nProvider, useI18n, useLocale };
